import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const deleteLineItem = (data) => {
    return axios.delete(`${apiurl?.deleteLineItemLevel}/${data?.id}/${data?.reason}`);
};

    const deleteLineItemLevel = () => {
        const queryClient = useQueryClient();
        return useMutation(deleteLineItem, {
            onSuccess: () => {
                queryClient.invalidateQueries('getPO');
            }
        });
    };

export default deleteLineItemLevel;
